import cardTypeList from 'dict/cardtype'
import payChannelList from 'dict/paychannel'
import utils from 'utils'


module.exports = {
    dotted(value, start, end) {
        start = start || 3;
        end = end || 7;
        if (!value) {
            return ''
        } else if (value.length === 2){
            return '*' + value.substring(1, start) + value.substring(end, value.length)
        } else if (value.length === 3){
            return '**' + value.substring(2, start) + value.substring(end, value.length)
        }else if (value.length === 4){
            return '***' + value.substring(3, start) + value.substring(end, value.length)
        } else if (value.length === 15) {
            //身份证只显示前三后四
            start = 3;
            end = 11;
            return value.substring(0, start) + '********' + value.substring(end, value.length)
        } else if (value.length === 18) {
            //身份证只显示前三后四
            start = 3;
            end = 14;
            return value.substring(0, start) + '***********' + value.substring(end, value.length)
        }else{
            return value.substring(0, start) + '****' + value.substring(end, value.length)
        }
    },
    //目前以localstorage存储  
    hospitalName(hospitalId) {
        var hospitals = JSON.parse(localStorage.getItem('hospitals'));
        for (let i = 0, length = hospitals.length; i < length; i++) {
            if (hospitals[i].hospitalId === hospitalId) {
                return hospitals[i].hospitalName;
            }
        }
        return '';
    },
    //目前以localstorage存储
    cardType(cardType) {
        for (let i = 0, length = cardTypeList.length; i < length; i++) {
            if (cardTypeList[i].key === cardType) {
                return cardTypeList[i].name;
            }
        }
        return '';
    },
    //tobe delete
    dateformat(date, format){
        format = format || 'yyyy-MM-dd'
        return new Date(date).format(format)
    },
    payChannel(payChannel) {
        for (let i = 0, length = payChannelList.length; i < length; i++) {
            if (payChannelList[i].key === payChannel) {
                return payChannelList[i].name;
            }
        }
        return '';
    },
    formatBracket(text) {
        if(text.length === 0){
            return text;
        }
        return '( ' + text + ' )';
    },
    formatFee(fee, needSpace) {
        if (needSpace === false) {
            return (fee / 10000).toFixed(4) + '元';
        }
        return (fee / 10000).toFixed(2) + ' 元';
    },
    dataFilter(data, tabId) {
        for (var i = 0;i<data.length;i++){
            if(tabId == data[i].recipeType) {
                return data
            }
        }
        return []
    },
    formatDate(dateString){
        var formatDate = "";
        if (dateString.length === 22 || dateString.length === 19 || dateString.length === 16) {
            // 2017-06-05 16:49:18  ->  06-05 16:49
            var date = new Date(Date.parse(dateString.substring(0, 16).replace(/-/g, "/")));
            var weekDay = utils.getWeekDay(date);
            formatDate = weekDay + ' ' + date.format('yyyy-MM-dd hh:mm');
            // 2017-06-07 07:00~17:59  ->  06-07 07:00~17:59
            if(dateString.length === 22){
                formatDate = formatDate + dateString.substring(16, 22);
            }
        } else if(dateString.length === 10){
            // 2017-05-26  ->  2017年05月26日
            formatDate = dateString.substring(0, 4) + '年' + dateString.substring(5, 7) + '月' + dateString.substring(8, 10) + '日';
        }
        return formatDate;
    },
    formatpayDate(formatDate){
        //ios new Data要转成2017/07格式
        const temDate = formatDate.replace(/-/g, "/");
        const week = ['周日','周一','周二','周三','周四','周五','周六'];
        const myData = new Date(temDate);
        const myformat = myData.format('yyyy-MM-dd hh:mm:ss');
        const myWeek = week[myData.getDay()];

        return myformat.substring(0, 11) + myWeek + myformat.substring(10, 16);
    },
    formatItemQty(itemQty){
        return parseFloat(itemQty).toFixed(2)
    },
    formatCharacterInfo(info) {
        if (info == "" || typeof (info) == "undefined") {
            return '-';
        }
        return info;
    },
    formatNum(num) {
        return (num >= 10 ? num: '0'+num);
    },
    isToday(date) {
        const curDate = new Date(date)
        const today = new Date();
        if ((curDate.getDate() === today.getDate()) && (curDate.getMonth() === today.getMonth())){
            return '挂号'
        } else {
            return '预约'
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/filters.js